import { LocalTime } from 'js-joda'

export class SelectItem {
    constructor(
        public value: string | LocalTime,
        public text: string
    ) { }
}
